import {Component, Input, OnInit} from '@angular/core';
import { ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';
import {MatDialog} from '@angular/material/dialog';
import {SubWindowTextComponent} from '@app/feature/store-editor/components-settings/sub-window-text/sub-window-text.component';

@Component({
  selector: 'app-countdown-setting',
  templateUrl: './countdown-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class CountdownSettingComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;

  constructor(public cs: CommonService, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.item.data = this.cs.setDefaultSetting(this.item.data);
  }

  openWindowText() {
 
    const dialogRef = this.dialog.open(SubWindowTextComponent, {
      width: '900px',
      height: '514px',
      data: this.item.data.textHtml
    });
    dialogRef.afterClosed().subscribe((res: string) => {
      if (res) {
        this.item.data.textHtml = res;
      }
    });
  }
}
